// extracted by mini-css-extract-plugin
module.exports = {"dateContainer":"CreditCardExpiryDate_dateContainer__u9oGu","date":"CreditCardExpiryDate_date__1lK1V"};